import { API_URL } from '@/config';

/**
 * Returns the URL of the audio file of clip `audioExfilId`. The endpoint replies with a redirect to a presigned S3
 * URL, so give this URL to an `<audio src>` or an `<a href>`, which follow the redirect. `fetch` and XHR follow it
 * too but do not expose the S3 URL.
 *
 * `download: true` makes the S3 response an attachment with a descriptive file name.
 */
export const getAudioClipUrl = (spotterId: string, audioExfilId: number, { download }: { download: boolean }): string =>
    `${API_URL}/user-rest/devices/${spotterId}/audio/${audioExfilId}${download ? '?download=true' : ''}`;
